import { PATHS } from 'shared/utils/paths'

export const isLayoutDisabled = (pathname: string) => {
  return [
    PATHS.login,
    PATHS.register,
    PATHS.forgotPassword,
    PATHS.resetPassword,
    PATHS.benefits,
    PATHS.emailConfirmation,
    PATHS.changeEmailConfirmation,
    PATHS.cms,
    PATHS.documents,
    PATHS.landing,
    PATHS.landingTest
  ].includes(pathname)
}

export const isCheckoutPage = (pathname: string) => {
  return [PATHS.cart, PATHS.delivery, PATHS.payment].includes(pathname)
}

export const isHeaderMinimalistic = (pathname: string) => isCheckoutPage(pathname)
